export function setItems(values, keys = Object.keys(values), definedOnly) {
  keys.forEach((key) => {
    const value = values[key];
    if (value) {
      localStorage.setItem(key, value);
    } else if (definedOnly) {
      localStorage.removeItem(key);
    }
  });
}

export function getItems(keys) {
  const result = {};
  keys.forEach((key) => {
    result[key] = localStorage.getItem(key);
  });
  return result;
}

export function removeItems(keys) {
  return keys.forEach(key => localStorage.removeItem(key));
}

export function getItemFromStoreAsBoolean(key) {
  const stringValue = localStorage.getItem(key);
  if (stringValue === 'true') return true;
  if (stringValue === 'false') return false;
  return undefined;
}
